import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DataShareService } from '../../services/data-share.service';

@Component({
  selector: 'app-time-out-dialog',
  templateUrl: './time-out-dialog.component.html',
  styleUrls: ['./time-out-dialog.component.scss']
})
export class TimeOutDialogComponent implements OnInit {

  @Input()
  idleState: any

  constructor(
    private shareService: DataShareService,
    public dialogRef: MatDialogRef<TimeOutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.shareService.dataSource.subscribe((data) => {
      if (data == 'closeMe') {
        this.dialogRef.close();
      } else {
        this.idleState = data;
      }
    })

  }
  close(): void {
    this.dialogRef.close();
  }
  ngOnInit() {
  }
  ngOnChange() {
  }

}



// WEBPACK FOOTER //
// ./src/app/main/shared/dialog/time-out-dialog/time-out-dialog.component.ts